<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="overlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <h4 class="title">Select Action</h4>
        <div class="close" v-on:click="close(false)"></div>
        <div class="roleItem" v-on:click="close(true, 'create')">
          <h4>Create Article</h4>
          <p>Create article based on title you wrote.</p>
        </div>
        <div class="roleItem" v-on:click="close(true, 'analyze')">
          <h4>Analyze Article</h4>
          <p>Get insightful information about article you wrote.</p>
        </div>
        <div class="roleItem" v-on:click="close(true, 'summarize')">
          <h4>Summarize Article</h4>
          <p>Get insightful information about article you wrote.</p>
        </div>
        <div class="roleItem" v-on:click="close(true, 'rewrite')">
          <h4>Rewrite Article</h4>
          <p>Rewrite the article with ChatGPT.</p>
        </div>
        <div class="roleItem" v-on:click="close(true, 'translate.en')">
          <h4>Translate to English</h4>
          <p>Translate this article to English using ChatGPT.</p>
        </div>
        <div class="roleItem" v-on:click="close(true, 'translate.id')">
          <h4>Translate to Bahasa</h4>
          <p>Translate this article to Bahasa Indonesia using ChatGPT.</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      next: null,
      d: null,
    };
  },
  methods: {
    open(d, n) {
      this.show = true;
      this.d = d;
      this.next = n;
    },
    close(b, v) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.modal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
    opacity: 1;
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    width: 420px;
    margin: auto;
    border-radius: 5px;
    padding: 20px 0;
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    h4{
      font-size: 24px;
      font-weight: 600;
      margin: 0 40px 20px;
    }
    .roleItem{
      padding: 10px 40px;
      cursor: pointer;
      margin: 0 0 4px;
      &:hover{
        background-color: #f5f5fe;
      }
      &.selected{
        background-color: #f5f5f5;
      }
      h4{
        font-size: 18px;
        margin: 0 0 2px;
      }
      p{
        color: #767676;
        font-size: 15px;
        margin: 0;
        line-height: 1.3;
      }
    }
  }
}
</style>
